<template>
  <div class="muteng-rule-container">
    <img class="logo" src="/static/images/muteng/logo.png" />
    <div class="content">
      <div class="rule-box">
        <div class="rule-top">
          <img src="/static/images/muteng/rule.png" class="rule-title-img" />
        </div>
        <div class="rule-bottom">
          <div class="rule-text" v-html="activityRule"></div>
          <div class="rule-shop">
            <wx-open-launch-weapp
              class="rule-shop-launch-btn"
              :appid="miniAppId"
              :username="miniAppOriginalId"
              :path="miniAppPage">
              <script type="text/wxtag-template">
                <img src="/static/images/muteng/go-shop.png" style="width: 100%; height: auto; display: block;" />
              </script>
            </wx-open-launch-weapp>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getJSSDK, getTemplateV2, getScoreConfig } from '../../api/api'
import wx from 'weixin-js-sdk'

export default {
  name: 'MuTengRule',
  data() {
    return {
      deptId: '',
      code: '',
      appId: process.env.ENV_NUM === '1' ? 'wxc537e3c625581d97' : 'wxbc22565b3e7a59fd',
      activityId: '',
      activityRule: '',
      shopUrl: '',
      miniAppId: '',
      miniAppOriginalId: '',
      miniAppPage: ''
    }
  },
  methods: {
    async queryTemplate() {
      const res = await getTemplateV2(this.deptId, this.code)
      if (res && res.data && res.data.data) {
        this.activityId = res.data.data.activityId || ''
        this.activityRule = res.data.data.activityRule || ''
      }
    },
    async queryScoreConfig() {
      const res = await getScoreConfig(this.deptId)
      if (res && res.data && res.data.data) {
        this.shopUrl = res.data.data.shopUrl || ''
        const data = this.shopUrl.split('|')
        this.miniAppId = data[0] || ''
        this.miniAppOriginalId = data[1] || ''
        this.miniAppPage = data[2] || ''
      }
    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, this.appId).then(res => {
        const data = res.data.data
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app'],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ]
        })
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          })
        })
      }).catch(err =>
        alert('获取微信授权失败' + err)
      )
    }
  },
  async mounted() {
    const params = this.$route.query
    this.deptId = params.deptId || ''
    this.code = params.code || ''
    if (this.deptId) {
      await this.queryTemplate()
      await this.queryScoreConfig()
      this.getWxJs()
    }
  }
}
</script>

<style scoped>
.muteng-rule-container {
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: #000;
  background-image: url('/static/images/muteng/bg2.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.logo {
  position: absolute;
  top: 5vh;
  right: 7vw;
  width: 35vw; /* 预设一个合理的宽度，后续可调整 */
  z-index: 10;
}

.content {
  position: relative;
  z-index: 5;
}

.rule-box {
  position: absolute;
  top: 65vh;
  left: 50%;
  transform: translateX(-50%);
  width: 80vw;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.rule-top {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 2vh;
}

.rule-title-img {
  width: 55vw;
}

.rule-bottom {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}

.rule-text {
  flex: 1;
  color: #ffffff;
  font-size: 2.8vw;
  line-height: 1.6;
  text-align: left;
  padding-right: 2vw;
}

.rule-text p {
  margin: 0.5vh 0;
}

.rule-shop {
  display: flex;
  align-items: flex-end;
}

.rule-shop-launch-btn {
  width: 12vw;
  display: block;
  line-height: 0;
}

.footer-text {
  position: absolute;
  bottom: 3vh;
  left: 10vw;
  color: #ffffff;
  font-size: 3.5vw;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/MuTeng/Rule.vue